import React from "react";
import { connect } from "react-redux";
import HeaderPlanMovilidad from "../../Util/Header";
import EtapasPlan from "./etapas";

class HeaderPlan extends React.PureComponent {
   render() {
    return (
      <div>
        <HeaderPlanMovilidad />
        { (this.props.sucursalId && (this.props.estadoProceso !== 0)) && <EtapasPlan /> }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sucursalId: state.global.sucursalId,
  estadoProceso: state.planMovilidad.estadoProceso,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderPlan);
